export default "__VITE_ASSET__wC6dV4P___"